import vueComponentOptions from 'components/InputSliderRange.vue';

const RangeInput = Vue.extend(vueComponentOptions);

module.exports = RangeInput;
